import { ModuleName } from '../interfaces/customer';
import { get, put } from '.';
import { buildUrl } from '@/api/utils';

export interface ModuleInfo {
  id: ModuleName;
}

export interface BatchModuleUpdateRequest {
  isEnabled: boolean;
  customerIds: number[];
}

export interface BatchModuleUpdateResult {
  totalCustomers: number;
  successCount: number;
  failureCount: number;
  errors: string[];
}

// Real API call to security service
export const updateModulesBatch = async (
  moduleName: string,
  request: BatchModuleUpdateRequest,
): Promise<BatchModuleUpdateResult> => {
  return put<BatchModuleUpdateResult>(
    buildUrl(`/v1/security/customers/modules/${moduleName}/batch`),
    request,
  );
};

export const getAvailableModules = async (): Promise<ModuleInfo[]> => {
  const moduleNames = await get<string[]>(
    buildUrl('/v1/security/customers/modules'),
  );

  return moduleNames.map((name) => ({
    id: name as ModuleName,
  }));
};

export const getModuleGroups = async (
  moduleName: string,
): Promise<number[]> => {
  return get<number[]>(buildUrl(`/v1/security/modules/${moduleName}/groups`));
};
